import pathToRegexp from 'path-to-regexp'
import querystring from 'querystring'
import { RouteParam } from './params'

export type Route = {
  path: string
  params?: RouteParam[]
}

export function matchRoute<R extends Route>(routes: R[], pathName: string): R | null {
  const [path, qs] = pathName.split('?')
  const route = getCurrentRoute(routes, path)
  if (!route) {
    return null
  }

  const paramNames = []
  const matchingRegex = pathToRegexp(route.path, paramNames)
  const values = matchingRegex.exec(path) || []

  let pathParams = []
  if (values.length && values.length > 1) {
    pathParams = extractPathParams(paramNames, values.slice(1))
  }

  const queryParams = extractQueryParams(qs)

  // First value is always the entire path, which is not interesting
  // in this context. Thus, skip it
  return {
    ...route,
    params: [...pathParams, ...queryParams]
  } as R
}

function extractQueryParams(qs) {
  const paramsObj = querystring.parse(qs)
  return Object.keys(paramsObj).map(key => {
    return { key, value: paramsObj[key] }
  })
}

function extractPathParams(params, values) {
  return values.map((item, idx) => {
    return {
      key: params[idx].name,
      value: values[idx]
    }
  })
}

function getCurrentRoute(routes: Route[], pathName: string): Route | undefined {
  return routes.find(route => {
    const regexp = pathToRegexp(route.path)
    return regexp.test(pathName)
  })
}
